// 信箱登入 驗證碼 驗證失敗
import Image from 'next/image';

const EmailVerifyFail = ({ t, onRetry }) => {
    return (
        <div>
            <div className="img-box w-[135px] aspect-[1/1] mx-auto">
                <Image
                    width={135}
                    height={135}
                    src="/images/icon/icon_verify_fail.svg"
                    alt="icon"
                />
            </div>

            <p className="text-h3 text-jblack mt-[10px] mb-[8px]">{t('FAIL')}</p>

            <p className="text-bd1m text-black9 opacity-[.8]">{t('MISTAKE')}</p>

            {/* 再試一次 */}
            <button
                className="text-white w-full block mt-[42px] rounded-[40px] text-btn1 text-center trans p-[16px] bg-purple"
                onClick={onRetry}
            >
                {t('AGAIN')}
            </button>
        </div>
    );
};

export default EmailVerifyFail;
